export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "a11y__carouselPagination--forward": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list, plural: _plural } = ctx;return _plural([_normalize(["Next Item"]), _normalize(["Next ", _interpolate(_list(0)), " Items "])])},
        "a11y__carouselPagination--backward": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list, plural: _plural } = ctx;return _plural([_normalize(["Previous Item"]), _normalize(["Previous ", _interpolate(_list(0)), " Items"])])}
      }
    }
  })
}
